import { type FC } from 'react';
import { useTranslation } from 'react-i18next';
import cn from 'classnames';

import { formatDateToEu } from '@/common/lib/date';
import { type LotterySeasonHistoryData } from '@/common/types/lottery';
import { StringSmall } from '@/components/Typography/Typography';

import css from './styles.module.scss';

interface LotterySeasonHistoryItemProps extends LotterySeasonHistoryData {
  isActive: boolean;
  handleClick: () => void;
}

const LotterySeasonHistoryItem: FC<LotterySeasonHistoryItemProps> = ({
  seasonId,
  totalPrizePool,
  finishedAt,
  isActive,
  handleClick,
}) => {
  const { t } = useTranslation();

  return (
    <div
      onClick={handleClick}
      className={cn(
        css.seasonHistoryItem,
        isActive && css['seasonHistoryItem--active'],
      )}
    >
      <StringSmall weight="bold" className="!text-[14px]">
        {t('Draw №{{seasonId}}', { seasonId })}
      </StringSmall>
      <StringSmall weight="bold" className="!text-[14px] justify-self-end">
        {`${totalPrizePool} $`}
      </StringSmall>
      <StringSmall weight="bold" className="!text-[14px] justify-self-end">
        {formatDateToEu(finishedAt)}
      </StringSmall>
    </div>
  );
};

export { LotterySeasonHistoryItem };
